import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJcsCustomerAccessRoute: InvariantJiraRoute = {
	name: 'products-jcs-customer-access',
	path: '/jira/settings/products/customerservice/customer-access',
	exact: true,
};
